import { ChallengeCard } from '@infl-ts/util-use-challenge-player';
import * as t from 'io-ts';
export var ChallengeList = t.array(ChallengeCard);
export var RecommendedChallenges = t.type({
  type: t.union([t.literal('unlocked'), t.literal('suggested')]),
  challenges: ChallengeList
});